import { Component, Input, OnInit } from '@angular/core';
import { map, take } from 'rxjs/operators';

import {
  AppointmentBookingState,
  AppointmentBookingStateService,
} from '@app/appointment/appointment-booking-state-service';
import { AppointmentRoutingStateService } from '@app/appointment/appointment-routing-state-service/appointment-routing-state.service';
import { FeatureFlags } from '@app/core/feature-flags/feature-flags';
import { LaunchDarklyService } from '@app/core/feature-flags/launchdarkly.service';
import { UserService } from '@app/core/user.service';
import { CareTopic } from '@app/shared/care-topic';
import { Office } from '@app/shared/office';
import { Provider } from '@app/shared/provider';
import { OmguiButtonSize, OmguiButtonType, OmguiButtonVariant } from '@omgui/omgui-button/omgui-button.component';

export enum BiosInBookingExperiment {
  Off = 'OFF',
  Control = 'ON CONTROL',
  WithSummary = 'ON WITH SUMMARY',
}

@Component({
  selector: 'om-provider-detail',
  templateUrl: './provider-detail.component.html',
  styleUrls: ['./provider-detail.component.scss'],
})
export class ProviderDetailComponent implements OnInit {
  @Input() provider: Provider;
  @Input() office: Office;
  @Input() remote: boolean;

  bookingState: AppointmentBookingState;
  topicName?: CareTopic;
  showOfficeDetails = true;
  providerLicensureString = '';

  get officeGoogleMapsLink(): string {
    const address = this.office.address;
    const { city, state, zip } = address;
    const entireAddress = `One Medical ${address.fullAddress}, ${city}, ${state}, ${zip}`;
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(entireAddress)}`;
  }

  get providerLicensure(): string {
    return 'Licensed in ' + this.bookingState.getSelectedState().name;
  }

  protected readonly ButtonVariant = OmguiButtonVariant;
  protected readonly OmguiButtonType = OmguiButtonType;
  protected readonly OmguiButtonSize = OmguiButtonSize;
  protected readonly displayProviderBios$ = this.launchDarklyService
    .featureFlag$(FeatureFlags.BHX_PROVIDER_BIOS_IN_BOOKING_EXPERIMENT, BiosInBookingExperiment.Off)
    .pipe(map(variant => BiosInBookingExperiment.WithSummary === variant));

  constructor(
    private launchDarklyService: LaunchDarklyService,
    private userService: UserService,
    private routingStateService: AppointmentRoutingStateService,
    private bookingStateService: AppointmentBookingStateService,
  ) {}

  ngOnInit() {
    this.topicName = this.routingStateService.appointmentRoutingState.topicName;
    this.bookingState = this.bookingStateService.getAppointmentBookingState();

    this.userService
      .hasAccessToRpc$()
      .pipe(take(1))
      .subscribe(hasAccess => {
        this.showOfficeDetails = !(
          hasAccess &&
          (this.topicName === CareTopic.RemoteVisit || this.bookingState.isRescheduling())
        );
        this.providerLicensureString = this.providerLicensure;
      });
  }
}
